<script>
import Layout from "@layouts/form";
import Perfil from "@forms/Perfil";

export default {
  page: {
    title: "Detalhes | Perfil"
  },
  components: { Layout, Perfil },
  props: {
    editable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      title: "Perfil",
      items: [
        {
          text: "Cadastros",
          href: "/Cadastros"
        },
        {
          text: "Perfil",
          href: "/Perfil"
        },
        {
          text: "Edição",
          active: true
        }
      ]
    };
  }
};
</script>

<template>
  <Layout :title="title" :items="items">
    <div class="page-content">
      <Perfil :editable="editable"></Perfil>
    </div>
  </Layout>
</template>
